/* eslint-disable no-shadow, no-param-reassign */
import { setCSSCustomUserOrCompanyColors } from '@/util/set-css-custom-properties';
import profileService from '@/services/profile/profile-service';
import { BOOST_ALLOWED_ROLES } from './constants/boost';

const state = {
	id: 0,
	aboutCompany: null,
	companyName: '',
	primaryPhoneNumber: '',
	primaryPhoneExtension: '',
	email: '',
	fambCompanyProfileURL: '',
	websiteUrl: '',
	companyLogo: {
		imageFormat: '',
		imageUri: '',
		referenceId: '',
	},
	complianceLogo: {
		imageFormat: '',
		imageUri: '',
		referenceId: '',
	},
	primaryAddress1: '',
	primaryAddress2: '',
	primaryCity: '',
	primaryState: '',
	primaryZipCode: '',
	pilotDripCampaignInd: null,
	isBranchedAccount: true,
	isBreakoutAccount: true,
	isActive: true,
	inactivationDate: '2019-08-28T15:42:21.491Z',
	socialMediaDetails: [],
	disclaimers: [''],
	brandItems: [],
	organizationType: '',
	nmlsNumber: '',
	licenses: [
		{
			licenseKey: '',
			licenseValue: '',
			expirationDate: '2019-08-28T15:42:21.491Z',
		},
	],
	dba: '',
	brokerId: '',
	rolodexEntityId: 0,
	parentRolodexEntityId: 0,
	institutionType: '',
	companyIndex: 0,
	blinkRegistrationInd: false,
	fambFeatureFlagIndicator: false,
	bigMacFeatureFlagInd: false,
	dripCampaignFeatureFlagInd: false,
};

const mutations = {
	SET_COMPANY_PROFILE(state, payload) {
		Object.assign(state, payload);
		state.companyIndex += 1;
	},
};

const actions = {
	async setCompanyProfile({ commit }, companyProfile) {
		if (companyProfile.aboutCompany === null) {
			companyProfile.aboutCompany = '';
		}
		commit('SET_COMPANY_PROFILE', companyProfile);
	},
	async updateCompanyProfile({ commit, state }, updatedCompanyProfile) {
		try {
			const companyProfile = { ...state, ...updatedCompanyProfile };
			await profileService.saveCompany(companyProfile);
			commit('SET_COMPANY_PROFILE', companyProfile);
		} catch (error) {
			return Promise.reject(error);
		}
	},
};

const getters = {
		hasGoogleMyBusiness(state) {
			const gmb = state.socialMediaDetails.find((el) => el.type === 'GoogleMyBusiness');
			return !!gmb && !!gmb.value;
	},
	/*
		Derives the color company color palette from the companyProfile brandItems
		Used by the Brand Builder Editor.
		@return object, color palette object.
	*/
	companyColorPalette(state) {
		return setCSSCustomUserOrCompanyColors(state.brandItems, 'Company Colors');
	},
	canAccessBoost(state, getters, rootState) {
		return BOOST_ALLOWED_ROLES.some((el) =>
			[
				...rootState.profileSwitcher.mainProfile.roles,
				...rootState.profile.roles,
			].includes(el),
		);
	},
	useLenderPrice(state) {
		const allowedBrokerIds = [
			'MIB3601B',
			'MIB3601',
			'AK1010',
			'AZ554Q',
			'CA773',
			'CA5415A',
			'MN1138E',
			'MN1138J',
			'MI5031',
			'CA221',
			'PA688',
			'ID1074',
			'FL12966',
		];
		return allowedBrokerIds.includes(state.brokerId);
	},
};

export default {
	state,
	mutations,
	actions,
	getters,
};
